export default function CardAuctionSeparator() {
  return <div style={{ marginLeft: 5, display: 'flex', width: 1, height: 12, backgroundColor: '#707070' }} />;
}
